// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-en-js": function componentSrcPages404EnJs() {
    return import("./../../src/pages/404.en.js"
    /* webpackChunkName: "component---src-pages-404-en-js" */
    );
  },
  "component---src-pages-404-es-js": function componentSrcPages404EsJs() {
    return import("./../../src/pages/404.es.js"
    /* webpackChunkName: "component---src-pages-404-es-js" */
    );
  },
  "component---src-pages-category-en-js": function componentSrcPagesCategoryEnJs() {
    return import("./../../src/pages/category.en.js"
    /* webpackChunkName: "component---src-pages-category-en-js" */
    );
  },
  "component---src-pages-category-es-js": function componentSrcPagesCategoryEsJs() {
    return import("./../../src/pages/category.es.js"
    /* webpackChunkName: "component---src-pages-category-es-js" */
    );
  },
  "component---src-pages-contact-en-js": function componentSrcPagesContactEnJs() {
    return import("./../../src/pages/contact.en.js"
    /* webpackChunkName: "component---src-pages-contact-en-js" */
    );
  },
  "component---src-pages-contact-es-js": function componentSrcPagesContactEsJs() {
    return import("./../../src/pages/contact.es.js"
    /* webpackChunkName: "component---src-pages-contact-es-js" */
    );
  },
  "component---src-pages-index-en-js": function componentSrcPagesIndexEnJs() {
    return import("./../../src/pages/index.en.js"
    /* webpackChunkName: "component---src-pages-index-en-js" */
    );
  },
  "component---src-pages-index-es-js": function componentSrcPagesIndexEsJs() {
    return import("./../../src/pages/index.es.js"
    /* webpackChunkName: "component---src-pages-index-es-js" */
    );
  },
  "component---src-pages-posts-en-js": function componentSrcPagesPostsEnJs() {
    return import("./../../src/pages/posts.en.js"
    /* webpackChunkName: "component---src-pages-posts-en-js" */
    );
  },
  "component---src-pages-posts-es-js": function componentSrcPagesPostsEsJs() {
    return import("./../../src/pages/posts.es.js"
    /* webpackChunkName: "component---src-pages-posts-es-js" */
    );
  },
  "component---src-pages-recovery-en-js": function componentSrcPagesRecoveryEnJs() {
    return import("./../../src/pages/recovery.en.js"
    /* webpackChunkName: "component---src-pages-recovery-en-js" */
    );
  },
  "component---src-pages-recovery-es-js": function componentSrcPagesRecoveryEsJs() {
    return import("./../../src/pages/recovery.es.js"
    /* webpackChunkName: "component---src-pages-recovery-es-js" */
    );
  },
  "component---src-templates-category-template-js": function componentSrcTemplatesCategoryTemplateJs() {
    return import("./../../src/templates/CategoryTemplate.js"
    /* webpackChunkName: "component---src-templates-category-template-js" */
    );
  },
  "component---src-templates-page-template-js": function componentSrcTemplatesPageTemplateJs() {
    return import("./../../src/templates/PageTemplate.js"
    /* webpackChunkName: "component---src-templates-page-template-js" */
    );
  },
  "component---src-templates-post-template-js": function componentSrcTemplatesPostTemplateJs() {
    return import("./../../src/templates/PostTemplate.js"
    /* webpackChunkName: "component---src-templates-post-template-js" */
    );
  }
};